import { render, staticRenderFns } from "./TrBox.vue?vue&type=template&id=11378c41&"
import script from "./TrBox.vue?vue&type=script&lang=js&"
export * from "./TrBox.vue?vue&type=script&lang=js&"
import style0 from "./TrBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports